const hasMoldId = (value: any) =>
  value !== undefined &&
  value !== null &&
  `${value}`.trim().length > 0 &&
  `${value}`.trim() !== "null" &&
  `${value}`.trim() !== "undefined";

// Descriptions come as "7288 - NAME"; a previous null id may have left a "null - " prefix
const moldIdFromDescription = (description?: string | null) =>
  `${description ?? ""}`.match(/^(?:\s*null\s*-)*\s*(\d+)\s*-/)?.[1] ?? null;

// Compositions reach us in several shapes (form, /sku-composition, PIS history, legacy records),
// and numeric ids must be kept: the backend rejects a molded component without mold_id
export const resolveMoldedMoldId = (component: any): string | null => {
  const id = [
    component?.mold_id,
    component?.mold,
    component?.full_objects?.mold?.id,
  ].find(hasMoldId);

  return hasMoldId(id)
    ? `${id}`.trim()
    : moldIdFromDescription(component?.mold_description);
};

const withoutLeadingZeros = (code: string) => code.replace(/^0+(?=\d)/, "");

// Renders "<code> - <name>" exactly once, whether or not the stored description already carries the code
export const formatMoldLabel = (code: any, description?: string | null) => {
  const segments = `${description ?? ""}`.split(" - ").map((s) => s.trim());
  const hasCode = hasMoldId(code);

  while (
    segments.length > 1 &&
    (segments[0] === "null" ||
      (hasCode && withoutLeadingZeros(segments[0]) === withoutLeadingZeros(`${code}`.trim())))
  ) {
    segments.shift();
  }

  const name = segments.join(" - ");
  return hasCode ? `${`${code}`.trim()} - ${name}` : name;
};

// For material/color/decoration/artwork the stored id may differ from the code shown (material 260 is "0404"),
// so a description that already starts with a numeric code is shown as is instead of being prefixed again
export const formatCodeLabel = (code: any, description?: string | null) => {
  const segments = `${description ?? ""}`.split(" - ").map((s) => s.trim());

  while (segments.length > 1 && segments[0] === "null") segments.shift();

  const name = segments.join(" - ");
  if (segments.length > 1 && /^\d+$/.test(segments[0])) return name;
  return hasMoldId(code) ? `${`${code}`.trim()} - ${name}` : name;
};

export const withResolvedMoldedMoldIds =(components: any[] = []) =>
  components.map((c) => ({ ...c, mold_id: resolveMoldedMoldId(c) }));
